import type { ReactNode } from "react";

export function deleteModalBracedCount(count: number): string {
  return `{${count}}`;
}
export function deleteModalSupporting(
  beforeBold: string,
  bold: ReactNode,
  afterBold: string
): ReactNode {
  return (
    <>
      {beforeBold}
      <strong>{bold}</strong>
      {afterBold}
    </>
  );
}
